import { useEffect, useState } from 'react';
import InputForm from '../../../../InputT';
import { useTranslation } from 'react-i18next';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';
import DataType from '../../../../../Types/DataTablePiclist';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import SearchInput from '../../../../SearchInput';
import SearchModal from '../../../../SearchModal';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../../TableResizable';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import Cheque from '../../../../../Models/Cheque';
import { Form, Radio } from 'antd';

const Swal = require('sweetalert2');
let Link = require('../../../../../Data/Data.json');


const Tab1 = (props: { etatG: boolean, form?: any, DataCheque: Cheque[], OnModif: Function, OnchangeEtat: Function }) => {

    const datas: DataType[] = [];
    //const {t,i18n}=useTranslation();
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [Filtre, setFiltre] = useState<string>("1");
    const auth = useAuthUser()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader();
    const [load,setload]=useState<boolean>(false);
 
    useEffect(()=>{
        if(load==false){
        props.OnchangeEtat(false)
            setload(true)
        }
    })



    //Initialisation des parametres de recherche
    let searchOp: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
    let searchCompte: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "101", Choix: 22 }
    let searchClient: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "101", Choix: 22 }

    const columns: ColumnsType<Cheque> = [
        {
            title: 'Date Saisie',
            dataIndex: 'DATOPE',
            ellipsis: true,
            width: 100,
            render: (text: any, reccord: any) => (
                <span>
                    {ReformatDate(text)}
                </span>
            )
        }
        ,
        {
            title: 'Client',
            dataIndex: 'Client',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'BANQUE',
            dataIndex: 'Lib_BANQUE',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'N° Compte',
            dataIndex: 'NUMCPT',
            ellipsis: true,
            width: 200,
            // filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.NUMCPT)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.SENSEC)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.REPECE)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.MONTANT)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.LIBELL)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Utilis)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Motif)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }
        },
        {
            title: 'Montant',
            dataIndex: 'MONTAN',
            ellipsis: true,
            width: 150,

        },
        {
            title: 'N° Chèque',
            dataIndex: 'NUMCHQ',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'N° Cpt cheque',
            dataIndex: 'CPTCHC',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'CPTRECOUVRE',
            dataIndex: 'CPTRECOUVRE',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'Remettant',
            dataIndex: 'REMETT',
            ellipsis: true,
            width: 200,
        },
        {
            title: "",
            dataIndex: 'RelObject',
            width: 1
        }
    ];

    let informationclient = {
        searchCptClient: {
            Titre: "Recherche ",
            label: "Compte Client ",
            name: "NUMCPT", params: searchClient
        },
        searchCodeOpe: {
            Titre: "Recherche Opération",
            label: "Libellé opération",
            name: "CODOPE", params: searchOp
        },
        searchCodeOpeCheck: {
            Titre: "Recherche Opération Chèque Payé",
            label: "Libellé commission ",
            name: "CODOPEC", params: searchOp
        },
        searchCompteComisCheck: {
            Titre: "Recherche Compte Commission",
            label: "Compte Commission",
            name: "NUMCPTCOM", params: searchCompte
        },

    }

    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const onSelectChange = (newSelectedRowKeys: any) => {
        // console.log('selectedRowKeys changed: ', Data[newSelectedRowKeys]);
        props.form.setFieldsValue(props.DataCheque[newSelectedRowKeys].RelObject);
        props.form.setFieldValue('lib_CODOPE', props.DataCheque[newSelectedRowKeys].RelObject.LIBECR);

        // let DateD = user.datjour;
        //
        props.form.setFieldValue('DATSAI', ReformatDate(props.DataCheque[newSelectedRowKeys].DATOPE));
        // props.form.setFieldValue('lib_CPTCHC', props.DataCheque[newSelectedRowKeys].RelObject.lib_BANCLT);
        setSelectedRowKeys(newSelectedRowKeys);
        props.OnModif();
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };


    return (
        <div className='tabItem' >
            <div>

                <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"} sx={{p: 1}}>
                     <legend> Retour chèque client de la banque </legend>
                      <Box fontStyle="inherit" className='border' width={"100%"} sx={{mb:1}} >
                      <Box fontStyle={"inherit"} display={"flex"} width={"88%"} sx={{p: 1}}>
                        <Form.Item name='EtatCheque' initialValue={true}   >
                            <Radio.Group disabled={false} onChange={e => { props.OnchangeEtat(e.target.value); }} style={{ display: 'flex' }}>
                                <Radio value={true}  style={{ fontWeight: "bold" }} > Chèque payé</Radio>
                                <Radio value={false}  style={{ fontWeight: "bold" }}> Chèque Impayé</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Box sx={{ visibility: 'hidden' }} >
                            <InputForm width={9} notRequired label={"identifiant"} name={"Id"} type='text' />
                        </Box>
                    </Box>
                    <Box >
                    <SearchInput dissabledCode={true} dissabledLib={false} width={4}  notRequired form={props.form} Titre={informationclient.searchCodeOpe.Titre} label={informationclient.searchCodeOpe.label} name={informationclient.searchCodeOpe.name} Parametre={informationclient.searchCodeOpe.params} />
                    <SearchInput dissabledCode={true} dissabledLib={false} form={props.form} width={4}  Titre={informationclient.searchCodeOpeCheck.Titre} label={informationclient.searchCodeOpeCheck.label} name={informationclient.searchCodeOpeCheck.name} Parametre={informationclient.searchCodeOpeCheck.params} />
                    <SearchModal disabled={true} width={4} form={props.form} Titre={informationclient.searchCptClient.Titre} label={informationclient.searchCptClient.label} name={informationclient.searchCptClient.name} Parametre={informationclient.searchCptClient.params} />
                        {/* <Box fontStyle="inherit" className='border-left' width={'50%'}>
                           
                            <SearchModal form={props.form} width={7} Titre={informationclient.searchCompteComisCheck.Titre} label={informationclient.searchCompteComisCheck.label} name={informationclient.searchCompteComisCheck.name} Parametre={informationclient.searchCompteComisCheck.params} />
                        </Box> */}
                    </Box>
                      </Box>
                    
                   <Box fontStyle="inherit" className='border' width={"100%"} sx={{mb:1}} >
                        <Table sticky={true} columns={columns} rowSelection={{ type: 'radio', ...rowSelection, getCheckboxProps: (reccord) => ({ disabled: false }) }} size='small' style={{ width: '100%' }} pagination={false} scroll={{ y: 350, x: 1200 }} dataSource={props.DataCheque} />
                    </Box>
                </Box>
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </div>
    );
}
export default Tab1;
